<template>
    <div @click.stop :class="disable&&'disable'">
        <div class="moneyInput-wrap bh" @click="chekeFlag(1)">
            <!-- 左侧数字输入框 -->
            <div class="left-num" :placeholder="placeholder">{{ showNum }}</div>
            <!-- 右侧光标效果 -->
            <div class="right-cursor b1" v-show="keyBoardFlag"></div>
            <div
                class="ico-clear bg-contain"
                v-show="keyBoardFlag&&keyInputNum.length"
                @click.stop="removeAll"
            ></div>
        </div>
        <!-- 输入键盘 -->
        <div class="moneyKey-wrap bh bc" v-if="keyBoardFlag">
            <!-- 左侧数字输入键盘 -->
            <div class="num-contain">
                <div class="numKey bh bc" v-for="(item,index) in numKey" :key="index">
                    <van-button
                        :disabled="flagArr[item]"
                        v-for="(item,index) in item"
                        :key="index"
                        @touchstart="changeNum(item,flagArr[item])"
                    >{{ item }}</van-button>
                    <!-- 小数点 -->
                    <van-button v-if="(numKey.length-1)==index" :disabled="true">.</van-button>
                    <!-- 隐藏按钮 -->
                    <van-button v-if="(numKey.length-1)==index" @click="chekeFlag(2)">
                        <div class="hide"></div>
                    </van-button>
                </div>
            </div>
            <!-- 右侧删除 确定按钮 -->
            <div class="del-contain bv bc">
                <van-button class="control-btn del-btn b1" @touchstart="delNum"></van-button>
                <van-button class="control-btn cancel-btn b1" @click="chekeFlag(2)">确 定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        // 绑定的值，通过父组件传递
        prop: "value",
        // 自定义事件名
        event: "update"
    },
    props: ["maxNum", "placeholder", "value", "disable"],
    data() {
        return {
            numKey: [["1", "2", "3"], ["4", "5", "6"], ["7", "8", "9"], ["0"]],
            keyInputNum: [],
            showNum: "",
            keyBoardFlag: false,
            flagArr: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        };
    },
    watch: {
        // 监听用户输入
        keyInputNum() {
            const me = this;
            me.toStr();
            me.checkNum();
        },
        value(v) {
            const result = v.toString();
            if (result.indexOf(".") != -1) {
                throw new Error("不能传小数，必须整数");
            }
            this.keyInputNum = result.split("");
        },
        disable(v) {}
    },

    created() {
        // 全局新增点击事件监听，点击其他区域时隐藏键盘弹窗
        document.addEventListener("click", this.hidden, false);
    },

    beforeDestroy() {
        // 销毁监听事件
        document.removeEventListener("click", this.hidden, false);
    },
    methods: {
        chekeFlag(v) {
            // 用户点击输入框时判断剩余最大金额是否为一位数
            const me = this,
                max = this.maxNum.toString(),
                // 剩余红包最大金额（整数） 的长度
                maxLen = max.length;
            // 检查是否禁用组件
            if (me.disable) {
                // 抛出事件
                me.$emit("disableclick");
                return;
            }
            if (v == 1) {
                me.keyBoardFlag = true;
            }
            if (v == 2) {
                me.keyBoardFlag = false;
            }
            // 变量
            let startNum = "",
                endNum = "",
                i;
            // 如果最大金额是一位数
            if (maxLen == 1) {
                startNum = parseInt(max[maxLen - 1]) + 1;
                endNum = 9;
                for (i = startNum; i <= endNum; i++) {
                    me.flagArr[i] = true;
                }
            }
        },
        // 用户输入数字放到数组
        changeNum(v, is) {
            if (!is) {
                this.keyInputNum.push(v);
            }
        },
        // 将数组转变成字符串
        toStr() {
            const me = this;
            me.showNum = me.keyInputNum.join("");
            // 双向绑定数据处理
            me.$emit("update", me.showNum);
        },
        // 删除数组最后一位
        delNum() {
            this.keyInputNum.pop();
        },
        // 清除所有数据
        removeAll() {
            this.keyInputNum = [];
        },
        // 监听用户输入，禁用按钮
        checkNum() {
            const me = this,
                // 用户输入的金额
                inputNum = parseInt(this.showNum),
                max = this.maxNum.toString(),
                // 剩余红包最大金额（整数） 的长度
                maxLen = max.length,
                // 剩余红包最大金额（整数）除去最后一位的数字
                maxNum = parseInt(
                    max
                        .split("")
                        .slice(0, maxLen - 1)
                        .join("")
                ),
                // 用户输入的金额的长度
                inputLen = this.showNum.length;
            // 变量
            let startNum = "",
                endNum = "",
                i;
            // 初始化键盘
            for (i = 0; i < 10; i++) {
                me.flagArr[i] = false;
            }
            // 如果最大金额是一位数
            if (maxLen == 1) {
                startNum = parseInt(max[maxLen - 1]) + 1;
                endNum = 9;
            }
            // 当输入长度比金额长度少一位时进行判断
            if (inputLen == maxLen - 1) {
                console.log(
                    "用户输入：" + inputNum,
                    "总金额除去最后一位：" + maxNum
                );
                // 用户输入大于
                if (inputNum > maxNum) {
                    startNum = 0;
                    endNum = 9;
                }
                // 用户输入等于
                if (inputNum == maxNum) {
                    // if(this.maxNum[maxLen - 1] == 0){

                    // }
                    startNum = parseInt(max[maxLen - 1]) + 1;
                    endNum = 9;
                    console.log(startNum);
                }
            }
            // 用户输入长度等于金额长度
            if (inputLen == maxLen) {
                startNum = 0;
                endNum = 9;
            }
            // 禁用按钮
            for (i = startNum; i <= endNum; i++) {
                me.flagArr[i] = true;
            }
        },
        // 隐藏键盘
        hidden() {
            this.keyBoardFlag = false;
        },
        reset() {
            this.hidden();
            this.removeAll();
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .van-button:after,
.van-button {
    border-radius: 0;
    width: 100%;
}
button {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
@keyframes blink {
    0% {
        border-left: 1px solid #fff;
    }
    50% {
        border-left: 1px solid #ff9a2b;
    }
    100% {
        border-left: 1px solid #fff;
    }
}
.ico-clear {
    width: 36px;
    height: 100%;
}
.moneyInput-wrap {
    width: 100%;
    height: 1em;
    line-height: 1em;
    .left-num {
        &:empty::before {
            position: absolute;
            content: attr(placeholder);
            color: #cac8c8;
            font-size: 34px;
        }
        &:focus::before {
            content: none;
        }
    }
    .right-cursor {
        animation: blink 1s infinite;
    }
}
.moneyKey-wrap {
    position: fixed;
    height: 336px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(217, 217, 217, 1);
    width: 100%;
    .num-contain {
        width: 75%;
        button {
            height: 84px;
        }
        .hide {
            width: 100%;
            height: 100%;
            background-image: url("~@/assets/imges/ico/yincang.png");
            background-size: 40%;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
    .del-contain {
        width: 25%;
        height: 100%;
        .del-btn.van-button--default {
            background: url("~@/assets/imges/ico/del.png") 50% 50% no-repeat;
            background-size: 30%;
            background-color: #f6f6f6;
        }
        .cancel-btn {
            background-color: #ff9a2b;
        }
    }
    .van-button--normal {
        font-size: 36px;
    }
}
</style>